import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { MenuBookIcon, QuestionAnswerIcon, DownloadIcon, SchoolIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
import { ARTICLE_PAGE_TYPE_COLUMN, ARTICLE_PAGE_TYPE_CASE_STUDY, ARTICLE_PAGE_TYPE_CONSULTING_CASE, ARTICLE_PAGE_TYPE_DOCUMENT, ARTICLE_PAGE_TYPES, } from '@/utils/constants/article/articleType';
export const ColumnTypeText = (props) => {
    const { articleType, className = '', isHover = true, isInline = false, isShowIcon = true, isShowLabel = true, textClassName = '', textColor = 'textGray', textSize = 'sm', } = props;
    const { icon: Icon, iconClassName, label, } = useMemo(() => {
        const targetType = ARTICLE_PAGE_TYPES.find((type) => type.value === articleType);
        let iconSetting;
        switch (targetType === null || targetType === void 0 ? void 0 : targetType.value) {
            case ARTICLE_PAGE_TYPE_COLUMN:
                iconSetting = {
                    color: isHover
                        ? 'group-hover:text-turquoise-green-100'
                        : 'text-turquoise-green-100',
                    icon: MenuBookIcon,
                };
                break;
            case ARTICLE_PAGE_TYPE_CASE_STUDY:
                iconSetting = {
                    color: isHover ? 'group-hover:text-blue-75' : 'text-blue-75',
                    icon: SchoolIcon,
                };
                break;
            case ARTICLE_PAGE_TYPE_CONSULTING_CASE:
                iconSetting = {
                    color: isHover ? 'group-hover:text-[#e0bb66]' : 'text-[#e0bb66]',
                    icon: QuestionAnswerIcon,
                };
                break;
            case ARTICLE_PAGE_TYPE_DOCUMENT:
                iconSetting = {
                    color: isHover
                        ? 'group-hover:text-coral-pink-75'
                        : 'text-coral-pink-75',
                    icon: DownloadIcon,
                };
                break;
            default:
                iconSetting = null;
                break;
        }
        return {
            icon: iconSetting === null || iconSetting === void 0 ? void 0 : iconSetting.icon,
            iconClassName: iconSetting === null || iconSetting === void 0 ? void 0 : iconSetting.color,
            label: targetType === null || targetType === void 0 ? void 0 : targetType.label,
        };
    }, [articleType, isHover]);
    return (_jsxs(IconTextGroup, Object.assign({ className: clsx(isHover && 'group', className), isInline: isInline }, { children: [isShowIcon && !!Icon && (_jsx(Icon, { className: iconClassName, color: isHover ? 'base' : 'none', size: 'sm' })), isShowLabel && !!label && (_jsx(Text, Object.assign({ className: clsx(isHover && 'group-hover:text-base', textClassName), color: textColor, size: textSize }, { children: label })))] })));
};
